import { render, staticRenderFns } from "./DiseaseCheckbox.vue?vue&type=template&id=028c93fa&scoped=true&lang=pug"
import script from "./DiseaseCheckbox.vue?vue&type=script&lang=js"
export * from "./DiseaseCheckbox.vue?vue&type=script&lang=js"
import style0 from "./DiseaseCheckbox.vue?vue&type=style&index=0&id=028c93fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c93fa",
  null
  
)

export default component.exports